import {
  Component,
  Input,
  Optional,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'suka-topbar',
  template: `
    <header
      class="topbar"
      role="banner"
      [attr.aria-label]="brand + ' ' + productName">

      <div class="container" *ngIf="insideContainer else elseTpl">
        <ng-container *ngTemplateOutlet="elseTpl"></ng-container>
      </div>

      <ng-template #elseTpl>
        <ng-template
          *ngIf="isTemplate(brand)"
          [ngTemplateOutlet]="brand">
        </ng-template>
        <a
          *ngIf="!isTemplate(brand)"
          class="topbar__name"
          [href]="href"
          (click)="navigate($event)">
          <img *ngIf="logoSrc" [src]="logoSrc" class="topbar__logo" [attr.alt]="brand" />
          <span *ngIf="!logoSrc" class="topbar__name--prefix">{{brand}}</span>
          <span *ngIf="productName" class="topbar__name--sufix">{{productName}}</span>
        </a>
        <ng-content></ng-content>
      </ng-template>
    </header>
  `
})
export class Topbar {
  /**
   *  Put topbar contents inside a container. Defaults to `false`
   */
  @Input() insideContainer = false;
  /**
   * Label that shows to the right of the `brand`.
   */
  @Input() productName: string;
  /**
   * Source for the header logo.
   */
  @Input() logoSrc: string;
  /**
   * Top level branding. Defaults to "Kushki"
   */
  @Input() brand: string | TemplateRef<any> = 'Kushki';
  /**
   * Optional link for the header
   */
  @Input() set href(v: string) {
    this._href = v;
  }

  get href() {
    return this.domSanitizer.bypassSecurityTrustUrl(this._href) as string;
  }
  /**
   * Array of commands to send to the router when the link is activated
   * See: https://angular.io/api/router/Router#navigate
   */
  @Input() route: any[];

  /**
   * Router options. Used in conjunction with `route`
   * See: https://angular.io/api/router/Router#navigate
   */
  @Input() routeExtras: any;

  /**
   * Emits the navigation status promise when the link is activated
   */
  @Output() navigation = new EventEmitter<Promise<boolean>>();

  protected _href = 'javascript:void(0)';

  constructor(
    protected domSanitizer: DomSanitizer,
    @Optional() protected router: Router
  ) { }

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }

  navigate(event) {
    if (this.router && this.route) {
      event.preventDefault();
      const status = this.router.navigate(this.route, this.routeExtras);
      this.navigation.emit(status);
    }
  }
}
